import axios from 'axios'

export default (topic = '', deviceId = '', noti = { body: "", title: "" }) => {
    const url = "https://fcm.googleapis.com/v1/projects/icaplayer-440b4/messages:send";
    var payload = {
        message: {
            notification: {
                body: noti.body,
                title: noti.title,
            },
            data: {}
        }
    }
    if (topic)
        payload.message.topic = topic
    if (deviceId)
        payload.message.token = deviceId

    getAccessToken().then(accessToken => {
        //console.log(accessToken)
        axios.post(url, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(({ data }) => {
                //console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error.response);
            });
    })
        .catch(e => {
            //console.log(e.message)
        })

}
async function getAccessToken() {
    return axios.get("https://ica-players.herokuapp.com")
    .then(({data})=>{
        //console.log('data',data);
        return data
    })
    .catch(e=>{
        //console.log("data",e)
    })
}